import { useEffect, useState } from 'react';
import API from '@/lib/api';

const EMPTY = { ordering_blocked: false, blocking: null, notices: [] };
let cache = null;
let inflight = null;
const listeners = new Set();

const fetchState = () => {
  if (!inflight) {
    inflight = API.get('/closures/current')
      .then(r => { cache = r.data; listeners.forEach(fn => fn(cache)); return cache; })
      .catch(() => cache || EMPTY)
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const invalidateClosures = () => { cache = null; return fetchState(); };

/** Fermetures & congés (public) : fermeture totale en cours ? notes à annoncer. Une seule requête partagée par page. */
export function useClosures() {
  const [state, setState] = useState(cache || EMPTY);
  useEffect(() => {
    listeners.add(setState);
    if (!cache) fetchState();
    const t = setInterval(fetchState, 10 * 60000);
    return () => { listeners.delete(setState); clearInterval(t); };
  }, []);
  return state;
}
